import { useContext } from 'react'

import { TransportRequestsContext } from './TransportRequestsProvider.tsx'

export type { TransportRequest } from './TransportRequestsProvider.tsx'

export const useTransportRequests = () => useContext(TransportRequestsContext)
